import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectLocale } from 'models/localization';
import ShowMore from 'components/utils/ShowMore';
import SpeakerItem from './SpeakerItem';

const RootContainer = styled.div`
  overflow: hidden;
`;

const EMPTY_TRANSLATIONS = {
  name: '',
  company: '',
  title: '',
  bio: '',
};

const MobileSpeakerList = ({ webinarId, speakers, backgroundRGB }) => {
  const locale = useSelector(selectLocale);
  return (
    <RootContainer>
      <ShowMore maxHeight={140} backgroundRGB={backgroundRGB}>
        {
          speakers.map(({
            id, avatar, translations,
          }) => {
            const {
              name, company, title, bio,
            } = translations[locale] || EMPTY_TRANSLATIONS;
            return (
              <SpeakerItem
                key={id}
                id={id}
                webinarId={webinarId}
                name={name}
                company={company}
                title={title}
                avatar={avatar}
                bio={bio}
              />
            );
          })
        }
      </ShowMore>
    </RootContainer>
  );
};

MobileSpeakerList.propTypes = {
  webinarId: PropTypes.number.isRequired,
  speakers: PropTypes.arrayOf(PropTypes.shape()),
  backgroundRGB: PropTypes.arrayOf(PropTypes.number),
};

MobileSpeakerList.defaultProps = {
  speakers: [],
  backgroundRGB: [255, 255, 255],
};

export default MobileSpeakerList;
